<nav id="sidebarMenu" class="sidebar d-md-block bg-primary text-white collapse" data-simplebar>
  <div class="sidebar-inner px-4 pt-3">
    <div class="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
      <div class="d-flex align-items-center">
        <div class="user-avatar lg-avatar mr-4">
          <img src="../volt_1.2/assets/img/team/profile-picture-3.jpg" class="card-img-top rounded-circle border-white" alt="Bonnie Green">
        </div>
        <div class="d-block">
          <h2 class="h6">Hi, Jane</h2>
          <a href="../pages/examples/sign-in.html" class="btn btn-secondary text-dark btn-xs"><span class="mr-2"><span class="fas fa-sign-out-alt"></span></span>Sign Out</a>
        </div>
      </div>
      <div class="collapse-close d-md-none">
          <a href="#sidebarMenu" class="fas fa-times" data-toggle="collapse"
              data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="true"
              aria-label="Toggle navigation"></a>
      </div>
    </div>
    <ul class="nav flex-column pt-3 pt-md-0">

      <li class="nav-item ">
        <a href="/#/" class="nav-link d-flex align-items-center justify-content-between">
            <span>
              <span class="sidebar-icon"><span class="fas fa-broadcast-tower"></span></span>
              <span class="sidebar-text">databroadcaster.io</span>
            </span>
        </a>
      </li>

      <li role="separator" class="dropdown-divider mt-4 mb-3 border-black"></li>

      <li class="nav-item" class:active="{currentPage==='Channels'}">
        <a href="/#/channels" class="nav-link">
          <span class="sidebar-icon"><span class="fas fa-stream"></span></span>
          <span class="sidebar-text">Channels</span>
        </a>
      </li>
      <li class="nav-item" class:active="{currentPage==='Templates'}">
        <a href="/#/templates" class="nav-link">
            <span class="sidebar-icon"><span class="fas fa-file-code"></span></span>
            <span class="sidebar-text">Templates</span>
        </a>
      </li>
      <li class="nav-item" class:active="{currentPage==='Users'}">
        <a href="/#/users" class="nav-link">
            <span class="sidebar-icon"><span class="fas fa-users"></span></span>
            <span class="sidebar-text">Users</span>
        </a>
      </li>
      <li class="nav-item" class:active="{currentPage==='Settings'}">
        <a href="/#/settings" class="nav-link">
            <span class="sidebar-icon"><span class="fas fa-cog"></span></span>
            <span class="sidebar-text">Settings</span>
        </a>
      </li>

      <li role="separator" class="dropdown-divider mt-4 mb-3 border-black"></li>
      
      <li class="nav-item" on:click={logout}>
        <span class="nav-link d-flex align-items-center">
          <span class="sidebar-icon"><span class="fas fa-sign-out-alt"></span></span>
          <span class="mt-1 sign-out-alt">Quit</span>
        </span>
      </li>

    </ul>
  </div>
</nav>


<script>
    import {push} from 'svelte-spa-router'
    
    import {App, stApp} from '../dbclib/App.js'
    import {User} from '../dbclib/User.js'
    
    export let currentPage

    function logout() {
        $stApp.user = new User()
        App.save()
        .then(() => push('/'))
    }

</script>